export class FileModel {

  uid: number;
  s3Path: string;
  fileName: string;
  fileType: string;
  datetime: string;
  base64: string;
  jobId: string;
  //conditionReportSlotIndex: number;
  loading: boolean;
  selected: boolean;
  
  constructor() {
    this.base64 = null;
  }
}